module.exports = __webpack_public_path__ + "img/valet-paul.292e60d2.jpeg";